import { KeyboardArrowDown } from '@mui/icons-material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { MenuItem } from 'components/ui/MenuItem';
import { OverflowTooltip } from 'components/ui/OverflowTooltip';
import { Tooltip } from 'components/ui/Tooltip';
import { ACCESS_LEVEL_OPTIONS, AccessLevelSelectProps, AccessLevelValue } from './AccessLevelSelect.props';
import { StyledAccessLevelSelect } from './AccessLevelSelect.styles';

const AccessLevelSelect = ({
  onChange,
  value,
  disabledValues,
  disabledValuesTooltip,
  ...props
}: AccessLevelSelectProps) => {
  const selectedOption = ACCESS_LEVEL_OPTIONS.find(option => option.value === value);

  return (
    <StyledAccessLevelSelect
      IconComponent={KeyboardArrowDown}
      onChange={event => onChange(event.target.value as AccessLevelValue)}
      renderValue={() =>
        selectedOption ? (
          <OverflowTooltip title={`${selectedOption.label} - ${selectedOption.description}`}>
            <Typography component="span" noWrap>
              <Typography component="span" fontWeight={600}>
                {selectedOption.label}
              </Typography>{' '}
              <Typography color="text.secondary" component="span">
                {selectedOption.description}
              </Typography>
            </Typography>
          </OverflowTooltip>
        ) : null
      }
      value={value}
      {...props}>
      {ACCESS_LEVEL_OPTIONS.map(option => {
        const isDisabled = !!disabledValues?.includes(option.value);
        return (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={isDisabled}
            sx={isDisabled ? { '&.Mui-disabled': { pointerEvents: 'auto !important' } } : undefined}>
            <Stack spacing={0.25}>
              <Tooltip placement="right" title={isDisabled ? (disabledValuesTooltip ?? '') : ''}>
                <Typography fontWeight={600} sx={{ width: 'fit-content' }}>
                  {option.label}
                </Typography>
              </Tooltip>
              <Typography color="text.secondary" variant="caption">
                {option.description}
              </Typography>
            </Stack>
          </MenuItem>
        );
      })}
    </StyledAccessLevelSelect>
  );
};

export default AccessLevelSelect;
